import { IAgency, IAgencyPrintout } from '../models/agency'
import Api from './index'

export const getAgency = (id: string) => Api<IAgency>('GET', `agencies/${id}`)
export const getAgencyPrintout = (id: string) => Api<IAgencyPrintout>('GET', `agencies/${id}/printout`)
